import React from "react";
import { connect } from "react-redux";
import { Modal, ModalHeader, Container, Row, Button } from "reactstrap";
import { Modal as ModalPopup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes, faThLarge } from "@fortawesome/free-solid-svg-icons";
import './Cases.scss'
import createIcon from "../../images/AddNew.svg";
import { AxiosResponse } from "axios";
import filterIcon from "../../images/filter-icon.svg";
import { ModalBody } from "reactstrap";
import CaseTrackerGrid from "./CaseTrackerGrid";
import CaseTrackerList from "./CaseTrackerList";
import CreateCaseFrom from "./CreateCaseFrom";
import CaseResponseModel from "../../models/Cases/CaseResponseModel";
import serachIcon from "../../images/search-gray.svg";
import {
  CaseFilterModel,
  CaseManagerFilter,
  CaseSelectedFilterModel,
  CaseStatusFilter,
  CaseTypeFilter,
} from "../../models/Cases/CaseFilterModel";
import { APP_Config } from "../../utils/AppConfig";
import Service from "../../services";
import CaseFilterLeads from "./CaseFilterLeads";
import { catchError } from "../../utils/Utils";
import { BankUserContext } from "../../bankUserContext";
import GridViewIcon from "../../images/grid-view.svg";
import GridViewInActiveIcon from "../../images/grid-view-inactive.svg";
import ListViewIcon from "../../images/list-view.svg";
import ListViewInActiveIcon from "../../images/list-view-inactive.svg";
import { getFilterValue, getSearchValue, setFilters, setSearch } from "../Filters/FiltersHelper";
import { set } from "lodash";

interface CaseTrackerMasterProps {
  data: any;
  disableforsuperuser: boolean;
  pathValues: any;
}

interface CaseTrackerMasterState {
  showCreateLeadModal: boolean;
  gridView: boolean;
  listView: boolean;
  filterModal: boolean;
  totalCasesData: Array<CaseResponseModel>;
  managerFilterData: Array<CaseManagerFilter>;
  statusFilterData: Array<CaseStatusFilter>;
  caseTypeFilterData: Array<CaseTypeFilter>;
  caseSelectedFiltersData: CaseSelectedFilterModel;
  sortColumn: string;
  sortDirection: string;
  serachValue: string;
  loader: boolean;
  formChange: number;
  filterIntialValues: any;
  allLORClients: any;
  caseDetails: any;
  gridActive: boolean,
  listActive: boolean,
  screenName: string;
}

const appTypeObj = [
  {
    value: "General",
    text: "General",
  },
  {
    value: "LOR",
    text: "LOR",
  },
];

class CaseTrackerMaster extends React.Component<
  CaseTrackerMasterProps,
  CaseTrackerMasterState
> {
  static contextType = BankUserContext;
  context: React.ContextType<typeof BankUserContext> | undefined;
  // roles = new RolesAuthentication();
  service: Service;
  constructor(props: CaseTrackerMasterProps) {
    super(props);
    this.state = {
      gridView: true,
      listView: false,
      showCreateLeadModal: false,
      filterModal: false,
      totalCasesData: [],
      managerFilterData: [],
      statusFilterData: [],
      caseTypeFilterData: [],
      sortColumn: "",
      sortDirection: "",
      serachValue: "",
      loader: false,
      caseSelectedFiltersData: new CaseSelectedFilterModel(),
      formChange: 0,
      filterIntialValues: {},
      allLORClients: [],
      caseDetails: null,
      gridActive: true,
      listActive: false,
      screenName: "cases",
      // orgId:this.contextType.bankuserDetails?.organization.orgId,
    };
    this.service = new Service();
  }
  setItems = (value: CaseSelectedFilterModel, items: CaseSelectedFilterModel, search?: string) => {
    items.orgId = this.context?.bankuserDetails?.organization?.orgId;
    items.sortColumn = this.state.caseSelectedFiltersData.sortColumn;
    items.sortDirection = this.state.caseSelectedFiltersData.sortDirection;
    items.searchKey = search ?? this.state.serachValue;
    items.caseManager = value?.caseManager;
    items.caseType = value?.caseType;
    items.caseStatus = value?.caseStatus;
    items.lor = value?.lor ?? [];
    items.searchKey = this.state.serachValue;
  }
  componentDidMount() {
    this.getAllLORClients();
    const view = localStorage.getItem("caseTrackerView")
    const items = new CaseSelectedFilterModel();
    const filters = getFilterValue(this.state.screenName);
    const search = getSearchValue(this.state.screenName);

    if (filters) {
      this.setItems(filters, items, search);
      this.setState({ caseSelectedFiltersData: items });
    } else {
      this.setItems(this.state.caseSelectedFiltersData, items, search)
    }

    if (search) {
      this.setState({ serachValue: search })
    }
    if (view) {
      if (view === "grid") {
        this.setState({ gridView: true, listView: false, gridActive: true, listActive: false })
      } else {
        this.setState({ gridView: false, listView: true, gridActive: false, listActive: true })
      }
    }
    // this.setState({ loader: true });
    // const items = new CaseSelectedFilterModel();
    // items.caseManager = this.state.caseSelectedFiltersData.caseManager;
    // items.orgId = APP_Config().REACT_APP_ORG_ID;
    // items.sortColumn = this.state.caseSelectedFiltersData.sortColumn;
    // items.sortDirection = this.state.caseSelectedFiltersData.sortDirection;
    // items.caseType = this.state.caseSelectedFiltersData.caseType;
    // items.caseStatus = this.state.caseSelectedFiltersData.caseStatus;
    // items.lor = this.state.caseSelectedFiltersData?.lor
    //   ? this.state.caseSelectedFiltersData.lor
    //   : [];
    // items.searchKey = this.state.serachValue;
    this.service.getCaseFilterData()
      .then((res: AxiosResponse<CaseFilterModel>) => {
        if (res.status === 200) {
          this.setState({
            managerFilterData: res.data.caseManagerFilter,
            statusFilterData: res.data.caseStatusFilter,
            caseTypeFilterData: res.data.caseTypeFilter,
          });
        }
      });
    this.getCasesByOrgHandler(items);
  }
  getValue = (element: any) => {
    if (element) {
      const businessName = element.businessName ? (element.businessName.length > 15 ? `${(element?.businessName).slice(0, 15)}...` : element?.businessName) : "--"
      const productName = element.productName ? (element.productName.length > 15 ? `${(element?.productName).slice(0, 15)}...` : element?.productName) : "--"
      const account = element.clientAccount ? (element?.clientAccount.length > 10 ? `${(element?.clientAccount).slice(0, 10)}...` : element?.clientAccount) : "--"
      return `${businessName} (${productName} - ${account})`
    }
  }

  getAllLORClients = () => {
    this.service.getAllLORClients(this.context?.bankuserDetails?.organization?.orgId).then((response: any) => {
      const data = response.data.map((element: any) => {
        return { text: this.getValue(element), value: element.clientId }
      })
      this.setState({ allLORClients: data })
    })
  };
  getCaseDataHandler = (caseId: any) => {
    this.setState({
      showCreateLeadModal: !this.state.showCreateLeadModal,
    });
    this.service
      .getFinCaseByCaseId(caseId)
      .then((res: any) => {
        this.setState({ caseDetails: res?.data });
      })
      .catch((err: any) => catchError(err, true));
  };

  getCasesByOrgWithFilters = (
    caseManager: string[],
    caseType: string[],
    status: string[],
    lor: string[]
  ) => {
    const items = new CaseSelectedFilterModel();
    items.caseManager = caseManager;
    items.orgId = this.context?.bankuserDetails?.organization?.orgId;
    items.sortColumn = this.state.caseSelectedFiltersData.sortColumn;
    items.sortDirection = this.state.caseSelectedFiltersData.sortDirection;
    // items.caseType = caseType?.map((m:any)=>m.value);
    items.caseType = caseType;
    items.caseStatus = status;
    items.lor = lor?.length > 0 ? lor : this.state.caseSelectedFiltersData.lor;
    items.searchKey = this.state.serachValue;
    this.getCasesByOrgHandler(items);
    this.setState({ caseSelectedFiltersData: items });
    setFilters(this.state.screenName, items)
  };
  getCasesByOrgWithSorting = (sortColumn: string, sortDirection: string) => {
    //set sort column and direction instate
    this.setState({ sortColumn: sortColumn, sortDirection: sortDirection });
    const items = new CaseSelectedFilterModel();
    items.caseManager = this.state.caseSelectedFiltersData.caseManager;
    items.orgId = this.context?.bankuserDetails?.organization?.orgId;
    items.sortColumn = sortColumn;
    items.sortDirection = sortDirection;
    items.caseType = this.state.caseSelectedFiltersData.caseType;
    items.caseStatus = this.state.caseSelectedFiltersData.caseStatus;
    items.lor = this.state.caseSelectedFiltersData?.lor
      ? this.state.caseSelectedFiltersData.lor
      : [];
    items.searchKey = this.state.serachValue;
    this.getCasesByOrgHandler(items);
    this.setState({ caseSelectedFiltersData: items });
    setFilters(this.state.screenName, items)
  };
  getSearchHandler = (event: any) => {
    //set balance types instate
    this.setState({ serachValue: event.target.value });
    const items = new CaseSelectedFilterModel();
    items.caseManager = this.state.caseSelectedFiltersData.caseManager;
    items.orgId = this.context?.bankuserDetails?.organization?.orgId;
    items.sortColumn = this.state.caseSelectedFiltersData.sortColumn;
    items.sortDirection = this.state.caseSelectedFiltersData.sortDirection;
    items.caseType = this.state.caseSelectedFiltersData.caseType;
    items.caseStatus = this.state.caseSelectedFiltersData.caseStatus;
    items.lor = this.state.caseSelectedFiltersData?.lor
      ? this.state.caseSelectedFiltersData.lor
      : [];
    items.searchKey = event.target.value;
    this.getCasesByOrgHandler(items);
    this.setState({ caseSelectedFiltersData: items });
    setFilters(this.state.screenName, items)
    typeof event !== 'string' && setSearch(this.state.screenName, event?.target?.value)

  };
  getCasesByOrgHandler = (data: any) => {
    this.setState({ loader: true });
    this.service
      .getCaseList(data)
      .then((res: AxiosResponse<CaseResponseModel[]>) => {
        if (res.status === 200) {
          this.setState({
            totalCasesData: res.data,
            filterModal: false,
            loader: false,
          });
        }
      });
  };

  createLeadModal = () => {
    if (this.state.showCreateLeadModal) {
      this.getCasesByOrgHandler(this.state.caseSelectedFiltersData);
      this.setState({ caseDetails: null });
    }
    this.setState({
      showCreateLeadModal: !this.state.showCreateLeadModal,
    });
  };
  gridViewHandler = () => {
    this.setState({
      gridView: true,
      listView: false,
      listActive: false,
      gridActive: true,
    });
    localStorage.setItem("caseTrackerView", "grid")
  };
  listViewHanlder = () => {
    this.setState({
      listView: true,
      gridView: false,
      gridActive: false,
      listActive: true,
    });
    localStorage.setItem("caseTrackerView", "list")
  };
  filterModalHandler = () => {
    this.setState({
      filterModal: !this.state.filterModal,
    });
  };
  clearCaseManager = (index: number) => {
    const items = new CaseSelectedFilterModel();
    items.caseManager = this.state.caseSelectedFiltersData?.caseManager?.filter(
      (m: string, i: number) => i !== index
    );
    items.orgId = this.context?.bankuserDetails?.organization?.orgId;
    items.sortColumn = this.state.caseSelectedFiltersData?.sortColumn;
    items.sortDirection = this.state.caseSelectedFiltersData?.sortDirection;
    items.lor = this.state.caseSelectedFiltersData?.lor;
    items.caseStatus = this.state.caseSelectedFiltersData?.caseStatus;
    this.getCasesByOrgHandler(items);
    this.setState({ caseSelectedFiltersData: items });
    setFilters(this.state.screenName, items)
  };
  clearLor = (index: number) => {
    const items = new CaseSelectedFilterModel();
    items.caseManager = this.state.caseSelectedFiltersData?.caseManager;
    items.orgId = this.context?.bankuserDetails?.organization?.orgId;
    items.sortColumn = this.state.caseSelectedFiltersData?.sortColumn;
    items.sortDirection = this.state.caseSelectedFiltersData?.sortDirection;
    items.lor = this.state.caseSelectedFiltersData?.lor?.filter(
      (m: string, ind: number) => ind !== index
    );
    items.caseStatus = this.state.caseSelectedFiltersData?.caseStatus;
    this.getCasesByOrgHandler(items);
    this.setState({ caseSelectedFiltersData: items });
    setFilters(this.state.screenName, items)
  };
  clearLorOrGeneral = (index: number) => {
    const items = new CaseSelectedFilterModel();
    items.caseManager = this.state.caseSelectedFiltersData?.caseManager;
    items.orgId = this.context?.bankuserDetails?.organization?.orgId;
    items.sortColumn = this.state.caseSelectedFiltersData?.sortColumn;
    items.sortDirection = this.state.caseSelectedFiltersData?.sortDirection;
    items.lor = this.state.caseSelectedFiltersData?.lor;
    items.caseType = this.state.caseSelectedFiltersData?.caseType?.filter(
      (m: string, ind: number) => ind !== index
    );
    items.caseStatus = this.state.caseSelectedFiltersData?.caseStatus;
    this.getCasesByOrgHandler(items);
    this.setState({ caseSelectedFiltersData: items });
    setFilters(this.state.screenName, items)
  };
  clearCaseStatus = (index: number) => {
    const items = new CaseSelectedFilterModel();
    items.caseManager = this.state.caseSelectedFiltersData?.caseManager;
    items.orgId = this.context?.bankuserDetails?.organization?.orgId;
    items.sortColumn = this.state.caseSelectedFiltersData?.sortColumn;
    items.sortDirection = this.state.caseSelectedFiltersData?.sortDirection;
    items.lor = this.state.caseSelectedFiltersData?.lor;
    items.caseStatus = this.state.caseSelectedFiltersData?.caseStatus?.filter(
      (m: string, inde: number) => inde !== index
    );
    this.getCasesByOrgHandler(items);
    this.setState({ caseSelectedFiltersData: items });
    setFilters(this.state.screenName, items)
  };

  getFilterText(value: string, type: string) {
    if (type === "caseType") {
      return this.state.caseTypeFilterData.find(
        (m: CaseTypeFilter) => m.value == value
      )?.text;
    }
    if (type === "caseManager") {
      return this.state.managerFilterData.find(
        (m: CaseManagerFilter) => m.value == value
      )?.text;
    }
    if (type === "caseStatus") {
      return this.state.statusFilterData.find(
        (m: CaseStatusFilter) => m.value == value
      )?.text;
    }
    if (type === "lor") {
      return this.state.allLORClients.find((m: any) => m.value == value)?.text;
    }
    if (type === "lorOrGeneral") {
      return appTypeObj.find((m: any) => m.value == value)?.text;
    }
  }

  handleFormChange = (changedValue: number) => {
    this.setState({ formChange: changedValue });
  };

  displayLoaderText = () =>
    this.state.loader ? (
      <h4 className="offset-5 col-md-3">Fetching records</h4>
    ) : (
      <h4 className="offset-5 col-md-3 not-found">No records found</h4>
    );

  clearSelection = () => {
    const items = new CaseSelectedFilterModel();
    items.searchKey = this.state.serachValue;
    this.getCasesByOrgHandler(items);
    this.setState({ caseSelectedFiltersData: items });
    setFilters(this.state.screenName, items);
  };

  render() {
    const {
      gridView,
      listView,
      totalCasesData,
      filterModal,
      statusFilterData,
      managerFilterData,
      caseTypeFilterData,
      caseSelectedFiltersData,
      loader,
    } = this.state;
    return (
      <>
        <Container fluid className="fuildLayout">
          <Row>
            <div className="leadHeaderBox">
              <div className="leftSide mt-1">
                <span className="leadsCount">
                  Cases <span>({totalCasesData?.length})</span>
                </span>
                <span
                  className="createLead"
                  onClick={() => {
                    this.createLeadModal();
                  }}
                >
                  <img src={createIcon} alt="CreateIcon" /> Create New Case
                </span>
              </div>
              <div className="rightSide csSeachBox">
                <div className="filteredTextDiv">
                  {caseSelectedFiltersData?.caseManager?.map(
                    (m: string, index: number) => (
                      <span key={index} className="filteredText">
                        {this.getFilterText(m, "caseManager")}{" "}
                        <FontAwesomeIcon
                          icon={faTimes}
                          onClick={() => this.clearCaseManager(index)}
                        />{" "}
                      </span>
                    )
                  )}
                  {caseSelectedFiltersData?.caseStatus?.map(
                    (m: string, index: number) => (
                      <span key={index} className="filteredText">
                        {this.getFilterText(m, "caseStatus")}{" "}
                        <FontAwesomeIcon
                          icon={faTimes}
                          onClick={() => this.clearCaseStatus(index)}
                        />{" "}
                      </span>
                    )
                  )}
                  {caseSelectedFiltersData?.lor?.length !== 0
                    ? caseSelectedFiltersData?.lor?.map(
                      (m: string, index: number) => (
                        <span key={index} className="filteredText">
                          {this.getFilterText(m, "lor")}{" "}
                          <FontAwesomeIcon
                            icon={faTimes}
                            onClick={() => this.clearLor(index)}
                          />{" "}
                        </span>
                      )
                    )
                    : caseSelectedFiltersData?.caseType?.map(
                      (m: string, index: number) => (
                        <span key={index} className="filteredText">
                          {this.getFilterText(m, "lorOrGeneral")}{" "}
                          <FontAwesomeIcon
                            icon={faTimes}
                            onClick={() => this.clearLor(index)}
                          />{" "}
                        </span>
                      )
                    )}
                  { }
                </div>
                <div className="searchBox">
                  <img
                    src={serachIcon}
                    className="searchIcon"
                    alt="serachIcon"
                  />
                  <input
                    type="text"
                    className="leadSearch"
                    placeholder="Search by Case"
                    onChange={(e) => this.getSearchHandler(e)}
                  />
                </div>
                <Button className="filter" onClick={this.filterModalHandler}>
                  <img src={filterIcon} alt="filterIcon" /> Filters
                </Button>
                <span className="gridView">
                  <img src={this.state.gridActive ? GridViewIcon : GridViewInActiveIcon} onClick={this.gridViewHandler} alt="GridViewIcon" />
                  {/* <FontAwesomeIcon
                    className={
                      gridView ? "gridViewIcon active" : "gridViewIcon"
                    }
                    onClick={this.gridViewHandler}
                    icon={faThLarge}
                  /> */}
                </span>
                <span className="listView">
                  <img src={this.state.listActive ? ListViewIcon : ListViewInActiveIcon} onClick={this.listViewHanlder} alt="ListViewIcon" />
                  {/* <FontAwesomeIcon
                    className={
                      listView ? "listViewIcon active" : "listViewIcon"
                    }
                    onClick={this.listViewHanlder}
                    icon={faBars}
                  /> */}
                </span>
              </div>
            </div>
          </Row>
          <Row>
            {totalCasesData ? (
              <>
                {totalCasesData?.length === 0 && this.displayLoaderText()}
                {totalCasesData?.length > 0 && gridView === true && (
                  <CaseTrackerGrid
                    CasesData={totalCasesData}
                    getCaseDataHandler={this.getCaseDataHandler}
                  />
                )}
                {totalCasesData?.length > 0 && listView === true && (
                  <CaseTrackerList
                    CasesData={totalCasesData}
                    getCasesByOrgWithSorting={this.getCasesByOrgWithSorting}
                    oppotuntiesOrNot={false}
                  />
                )}
              </>
            ) : (
              this.displayLoaderText()
            )}
          </Row>

          {/* Modal for filter */}
          <ModalPopup
            show={filterModal}
            onHide={this.filterModalHandler}
            className="filterModal caseTrackerFilterModal"
            autoFocus={false}
          >
            <ModalPopup.Header closeButton>Filters</ModalPopup.Header>
            <ModalPopup.Body>
              <CaseFilterLeads
                caseStatusFilterData={statusFilterData}
                managerFilterData={managerFilterData}
                caseTypeFilterData={caseTypeFilterData}
                closeHandler={this.filterModalHandler}
                getCasesByOrgWithFilters={this.getCasesByOrgWithFilters}
                trackerName="caseTracker"
                allLORClients={this.state.allLORClients}
                appTypeObj={appTypeObj}
                selectedFiltersData={caseSelectedFiltersData}
                clearSelection={this.clearSelection}
              />
            </ModalPopup.Body>
          </ModalPopup>
          {/* Model for create Lead */}
          <ModalPopup
            className="createCaseModal"
            size="xl"
            show={this.state.showCreateLeadModal}
            onHide={this.createLeadModal}
          >
            <ModalPopup.Header closeButton>
              <div className="caseTaskModal-header">Create New Case</div>
            </ModalPopup.Header>
            <ModalPopup.Body>
              <CreateCaseFrom
                toogleHandle={this.createLeadModal}
                title={"Create New Case"}
                handleFormChange={this.handleFormChange}
                getCasesByOrgHandler={this.getCasesByOrgHandler}
                allLORClients={this.state.allLORClients}
                caseDetails={this.state.caseDetails}
              />
            </ModalPopup.Body>
          </ModalPopup>
        </Container>
      </>
    );
  }
}
const mapStateToProps = (state: CaseTrackerMasterState) => ({
  data: state,
});

export default connect(mapStateToProps)(CaseTrackerMaster);
